import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { FancyShareApi } from 'api/ApiHelper';

export const useUnLikeFancyShareMutation = (fancyShareId: number, options: UseMutationOptions) =>
  useMutation({ mutationFn: () => FancyShareApi.unlikeFancyShare(fancyShareId), ...options });
